import { render, staticRenderFns } from "./TextareaRead.vue?vue&type=template&id=3cbc2958&"
import script from "./TextareaRead.vue?vue&type=script&lang=js&"
export * from "./TextareaRead.vue?vue&type=script&lang=js&"
import style0 from "./TextareaRead.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports